import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent } from '@shared/ui';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';
import { DynamicFormControlMetadata } from '@shared/dynamic-form';

@Component({
  selector: 'dynamic-form-text-control',
  templateUrl: 'text-control.component.html',
  styleUrls: ['text-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ParFormFieldComponent],
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormTextControlComponent,
    },
  ],
})
export class DynamicFormTextControlComponent extends AbstractDynamicFormControl {
  getValueChangeEvent({
    meta,
    event,
  }: {
    meta: DynamicFormControlMetadata<unknown>;
    event: Event;
  }) {
    const valueChangeAction = meta.actions?.find((a) => a.key === 'keyup');
    if (event) {
      return valueChangeAction?.actionCallbackFn(event);
    }
  }
}
